import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ZipDownloadImage } from '../interfaces/download.interface';

export const donwloadImagesZip = async (folderName: string, images: ZipDownloadImage[]) => {
    const zip = new JSZip();

    const fetchImage = async (url: string, filename: string) => {
        const response = await fetch(url);
        const blob = await response.blob();
        zip.file(filename, blob);
    };

    const imagePromises = images.map((image) => fetchImage(image.url, image.filename));

    await Promise.all(imagePromises);

    zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, folderName);
    });
};
